import React, { useEffect, useState } from 'react';
import Sidebar from '../component/layout/sidebar';
import Header from '../component/layout/header';
import Header2 from '../component/common/title';
import './sec-event.css'
import pic25 from '../assets/pic25.png'
import pic26 from '../assets/pic26.png'
import pic27 from '../assets/pic27.png'
import pic28 from '../assets/pic28.png'
import { supabase } from '../supabase';
import './sec-event-content-mangement.css'
import Contentmangementnav from '../component/common/contentnav';
import pic42 from '../assets/pic42.png'


const Feedbackmangement = () => {
    
    const [Feeback, setFeeback] = useState([]);
    const [search, setSearch] = useState('');
    const [filter, setFilter] = useState('');
    
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    
    
    useEffect(() => {
    const getFeedback = async () => {
        const { data, error } = await supabase
        .from('Feeback')
        .select(`
            *,
            Users:user_id (
            user_name,
            profile
            ),
            Events:Event_id (
            Event_title
            )
        `);

        if (error) {
        console.log("FEEDBACK ERROR:", error);
        return;
        }

        setFeeback(data || []);
    };

    getFeedback();
    }, []);
    
    
    
const filteredFeedback = Feeback.filter((item) => {
  const matchesSearch =
    (item.comment?.toLowerCase() || '').includes(search.toLowerCase()) ||
    (item.Users?.user_name?.toLowerCase() || '').includes(search.toLowerCase()) ||
    (item.Events?.Event_title?.toLowerCase() || '').includes(search.toLowerCase());

  let matchesFilter = true;

    if (filter === 'shown') {
      matchesFilter = item.show === true;
    }

    if (filter === 'hidden') {
      matchesFilter = item.show === false || item.show === null;
    }

      if (filter === 'high') {
      matchesFilter = item.Rating >= 4;
    } else if (filter === 'low') {
      matchesFilter = item.Rating < 4;
    }

    return matchesSearch && matchesFilter;
    
});



    return ( 
        
<section className='main-dashboard-container'>            
            <Sidebar isOpen={isSidebarOpen}  /> 
            <section className='container-right-info'>
                    <section className='header-container'>
                        <Header  onMenuClick={() => setIsSidebarOpen(!isSidebarOpen)}  />
                    </section>

                    <section className='information-container'>
                        <article className='header-cont-event'>
                           <Header2 
                            title="Landing Page Content"  
                            para="Manage featured events, FAQs, and testimonials"
                            />
                     
                        
                        </article>



<section className='container-table-and-section'>


                        <Contentmangementnav />



                        <section className='container-table-eventp'>
                            <fieldset className="input-wrapper">
                                <input 
                                  className='input-search'
                                    placeholder="Search events..."
                                    value={search}
                                    onChange={(e) => setSearch(e.target.value)} />
                                <img src={pic25} className="search-icon" alt="search" />
                            </fieldset>
                            <fieldset className='container-inputs-event-p'>
                                  <div className="select-wrapper">
                                    <img src={pic28} className="arrow-icon" alt="arrow" />
                                    <img src={pic26} className="select-icon" alt="filter" />
                                <select
                                className="input-search select-style"
                                value={filter}
                                onChange={(e) => setFilter(e.target.value)}
                                >
                                      <option value="">Filter by</option>

                                        <option value="shown">Shown</option>
                                        <option value="hidden">Hidden</option>
                                         <option value="high">High Rating</option>
                                    <option value="low">Low Rating</option>
                                </select>
                                </div>


                            </fieldset>



                             <div className="table-container" >
                                 <table className='table-table-concert-mangem'>
                                                                   
                                {filteredFeedback.map((item) => { return <tbody key={item.id}>
                               
                                                                 <tr className="row-table2-contenttt">

                                                <div className="container-table-info-row-sec">

                                                    <div className='main-info'>

                   
                                                    <article className='row-aboutt2'>
                                                        <img src={item.Users?.profile} alt='' className="icon-about" />

                                                        <div>
                                                        <h2 className="header-support">
                                                            {item.Users?.user_name}
                                                        </h2>

                                                        <h3 className="sentfrom-support">
                                                            {item.Events?.Event_title}
                                                        </h3>

                                                        </div>
                                                    </article>

                                                        <figure className='container-star'>

                                                    <h3 className="sentfrom-support">
                                                        {item.Rating}
                                                    </h3>
                                                        <img src={pic42} alt=''></img>
                                                        </figure>


                                                        <p className="sentfrom-support">
                                                            {item.comment}
                                                        </p>
                                                    </div>

                                                <label className="custom-checkboxl">
                                                   <input
                                                    type="checkbox"
                                                    checked={item.show || false}
                                                    onChange={async () => {
                                                        const newValue = !item.show;

                                                        await supabase
                                                        .from('Feeback')
                                                        .update({ show: newValue })
                                                        .eq('id', item.id);

                                                        setFeeback(prev =>
                                                        prev.map(el =>
                                                            el.id === item.id ? { ...el, show: newValue } : el
                                                        )
                                                        );
                                                    }}
                                                    />
                                                    <span className="checkmarkcontent"></span>
                                                    <h3 className="SHOW">Show on homepage</h3>
                                                </label>
                                                </div>

                                                </tr>
                               
                               
                               
                                             </tbody>
                                              })}
                                         </table>
                                </div>

                        </section>


                    </section>

            </section>
            </section>
        </section>

     );
}
 
export default Feedbackmangement;